import React from 'react';

interface PulseResizeHandleProps {
  onStartResize: (e: React.MouseEvent) => void;
  isResizing?: boolean;
}

/**
 * Visual resize handle for PulseTable column headers.
 *
 * Displays a vertical draggable handle on the right edge of resizable columns.
 * Hidden by default, visible on header hover, highlighted when actively resizing.
 *
 * @param onStartResize - Callback fired on mousedown to start resize
 * @param isResizing - Whether this handle is currently being dragged
 */
const PulseResizeHandle = ({
  onStartResize,
  isResizing = false,
}: PulseResizeHandleProps): React.ReactElement => {
  return (
    <div
      className={`absolute right-0 top-0 h-full w-4 -mr-2 cursor-col-resize opacity-0 group-hover:opacity-100 transition-opacity duration-150 flex items-center justify-center ${
        isResizing ? '!opacity-100' : ''
      }`}
      onMouseDown={onStartResize}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className={`w-0.5 h-2/3 rounded-full ${
          isResizing ? 'bg-blue-500' : 'bg-neutral-400'
        }`}
      />
    </div>
  );
};

export default PulseResizeHandle;
